// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { ar } from "vuetify/locale";
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VHotkey } from 'vuetify/labs/VHotkey'
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
import { VMaskInput } from 'vuetify/labs/VMaskInput'
import { VColorInput } from 'vuetify/labs/VColorInput'




// Vuetify
import { createVuetify } from 'vuetify'

const lightTheme = {
  dark: false,
  colors: {
    background: "#f7f8fa",
    surface: "#FFFFFF",
    primary: "#74bd81",
    secondary: "#2196F3",
    error: "#DF1D41",
    info: "#1A395b",
    success: "#4CAF50",
    warning: "#E47E00FF",
    navBorder: "#EEEEEE",
    navIconSelected: "#FFFFFF",
  },

};
const darkTheme = {
  dark: true,
  colors: {
    background: "#141414",
    surface: "#181818",
    primary: "#74bd81",
    secondary: "#2196F3",
    error: "#DF1D41",
    info: "#4A88CBFF",
    success: "#4CAF50",
    warning: "#FB8C00",
    navBorder: "#2F2F2FFF",
    navIconSelected: "#FFFFFF",
  },

};

export default createVuetify({
  locale: {
    locale: "ar",
    fallback: "ar",
    messages: { ar },
  },
  theme: {
    defaultTheme: "lightTheme",
    themes: {
      lightTheme,
      darkTheme,
    },
  },
  components: {
    VDateInput,
    VHotkey,
    VStepperVertical,
    VMaskInput,
    VColorInput,
  },
  defaults: {
    VBtn: { elevation: 0, rounded: 'xl', style: 'text-transform: none' },
    VCard: { elevation: 0, style: 'border: 3px solid rgb(var(--v-theme-navBorder))', rounded: 'xl' },
    VNavigationDrawer: { style: "border-left: 3px solid rgb(var(--v-theme-navBorder))" },
  }
});
